<template>
  <div>
    <div class="filter" v-show="CView=='ticket_list' || $bus.getRole()=='admin'">
      <b-row>
        <label v-if="checkMobile()===false && $bus.getRole()=='admin' " class="col-md-3 my-auto" >客服代預約輸入票號:</label>
        <span class="col-md-6" @keyup.enter="getTicketInfoByTicketNo">
          <b-form-input v-show="$bus.getRole()=='admin'" class="col-md-12" type='text' v-model="ticketNo" v-b-tooltip.hover title="客服輸入票號" placeholder="AA票號完成按Enter" @change.native="getTicketInfoByTicketNo" ></b-form-input>
        </span>
      </b-row>
      <b-card-group deck>
        <b-card class="col-md-6 ticket-card" v-for="ticket in ticketList" :key="ticket.ticket_item_id" 
          :sub-title="ticket.ticket_project_name+'('+ticket.ticket_no+')'"
          @click="ticketCardClick(ticket)"
        >
          <table>
            <tr>
              <td style="width:80%;">
                <img style="width:100%;" :src="getTicketImg(ticket)" />
              </td>
              <td style="width:20%;">
                <qrcode-vue value="https://tw.shopping99.com" size=64 level="H"></qrcode-vue>
                <span v-if="ticket.in_negotiate_info.negotiate_id>0">
                  {{ticket.in_negotiate_info.from}}
                  {{ticket.in_negotiate_info.store_name}}的{{ticket.in_negotiate_info.negotiate_target_start_time}}
                  {{getRestTime(ticket.in_negotiate_info.expire_time)}}</span>
              </td>
            </tr>
          </table>
          <!--<div>
            <img class="col-md-10" :src="getTicketImg(ticket)" />
            <qrcode-vue class="col-md-1" value="https://tw.shopping99.com" size=80 level="H"></qrcode-vue>
          </div>-->
        </b-card>
      </b-card-group>
      <div v-if="ticketList.length==0&&$bus.getRole()!='admin'"><label>你還沒有票還不可可後補預約啦</label></div>
    </div>
    <div v-show="CView=='schedule' || $bus.getRole()=='admin'">
      <b-form-select id="store_select" v-model="selectedStore" @change="storeChanged" class="col-md-3 m-2" v-b-tooltip.hover title="請選擇分店(選不了的分店是該分店當下未提供預約排程)">
        <option :value="store" :disabled="store.ready_offer_service==0"  v-for="store in storeList" :key="store.id">{{store.store_name}}</option>
      </b-form-select>
      <b-form-select id="service_select" v-show="TicketServiceList.length>1" v-model="selectedServiceItem" class="col-md-4 m-2">
        <option :value="service" v-for="service in TicketServiceList" :key="service.id">{{service.service_name}}</option>
      </b-form-select>
      <div class="reserved-ticket" v-show="Mode=='reserved'">
        
      </div>
      <div class="calendar-wrapper" v-show="Mode=='calendar'">
        <b-button v-show="$bus.getRole()=='user'" @click.prevent.stop="CView='ticket_list'" >回到票卷列表</b-button>
        <h4>檢視預約行事曆</h4>
        <calendar-view
          :show-date="showDate"
          displayPeriodUom="month"
          :events="eventList"
          @click-event="SwitchDateE"
          :dateClasses="myDateClasses"
          :periodChangedCallback="changeViewPeriod"
          class="theme-default">
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate" />
        </calendar-view>
      </div>
      <div v-show="Mode=='plot'">
        <h5>預約時段操作檢視<b-button @click.prevent.stop="BackToCalendar">回到日曆</b-button></h5>
        <b-card-group deck >
          <b-card class="col-md-5 event-card" v-for="plot in dayPlots" :key="plot.plot_id" 
            :class="getPlotCardClass2(plot)"
            :title="plot.time_str"
            @click="plotClick2(plot)"
          >
            <span v-html="parseCardContent2(plot)"></span>
          </b-card>
        </b-card-group>
      </div>
    </div>
    <b-modal
      ref="showApply"
      v-model="modalNegotiateAplly"
      hide-footer
      :static="true"
    >
      申請{{this.applyTime}}的劃位
      <b-form-input placeholder="輸入向店家說的話"></b-form-input>
      <b-button @click="modalNegotiateAplly=false">取消</b-button><b-button @click="modalNegotiateAplly=false">確認</b-button>
    </b-modal>  
  </div>
</template>

<script>

import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
require("vue-simple-calendar/static/css/default.css")
require("vue-simple-calendar/static/css/holidays-us.css")
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'MakeReservation',
  components: {
    CalendarView,
    CalendarViewHeader,
    QrcodeVue
  },
  data: function () {
    return {
      tickTime:null,
      Mode: "calendar",
      CView:"ticket_list",
      showDate: new Date(),
      applyTime:"",
      eventList:[],
      CalendarState:Object,
      eventDirty: false,
      myDateClasses: {},
      ticketNo: "",
      ticketList: [],
      selectedTicketInfo: {},
      storeList: [],
      selectedStore: {},
      TicketServiceList: [],
      selectedServiceItem: {},
      workingTicket: {},
      work_item_id:0,
      work_do_item_id:0,
      work_ticket_project_id:0,
      dayPlots: [],
      negotiate_info:{},
      modalNegotiateAplly:false
    }
  },
  props: [

  ],
  methods: {
    // 實驗動態倒數計時,利用updateCount無窮循環每秒一次更新this.tickTime
    // 僅為實驗性質,前端票夾不在這裡開發
    getRestTime(expire_time) {
      if (!expire_time || Date.parse(new Date(expire_time)) < this.tickTime ) {
        // 要去ticketList把對應in_negotiate_info清掉否則就不會更新隱藏
        return "已過期"
      }
      const msec = Date.parse(new Date(expire_time)) - this.tickTime
      let min = parseInt(msec / 1000 / 60 % 60)
      let sec = parseInt(msec / 1000 % 60)
      return "剩餘:"+min+"分"+sec+"秒"
    },
    updateCount() {
      const that = this
      this.tickTime = Date.parse(new Date())
      // console.log(this.tickTime)
      setTimeout(function () {
        that.updateCount()
      }, 1000)
    },
    setShowDate(d) {
				this.showDate = d;
    },
    changeViewPeriod(periodObj) {
      this.CalendarState = {
        'periodStart': this.toISODateString(periodObj.periodStart),
        'periodEnd': this.toISODateString(periodObj.periodEnd)
      }
      if (this.Mode === 'calendar') {
        this.getStoreCalendar()
      }
    },
    storeChanged() {
      setTimeout(() => {
        if (this.selectedStore.merchant_store_id && this.selectedServiceItem.ticket_project_service_item_id) {
          this.getStoreCalendar()
        }        
      }, 200);
    },
    // @click-date="SwitchDate"拿掉,改從事件點,這樣,不可預約候補的日期可避免無謂查詢
    /*SwitchDate(d) {
      this.myDateClasses = {}
      let key = this.toISODateString(d) // year + '-' + (month<10?'0':'') + month + '-' + date
      this.myDateClasses[key] = ['orange']
      this.setShowDate(d)
      this.Mode = 'plot'
      setTimeout(() => {
        this.getDayPlots()
      }, 50);
    },*/
    SwitchDateE(evt) {
      if (evt.title !== '可劃位') {
        return
      }
      const d = new Date(evt.startDate)
      this.myDateClasses = {}
      this.myDateClasses[evt.startDate] = ['orange']
      this.eventDirty = false
      // mode要提早切換,才能避免日曆日期切換時浪費的一次api呼叫(切換到看不到也是切換 = = )
      this.Mode = 'plot'
      this.setShowDate(d)
      setTimeout(() => {
        this.getDayPlots2()
        
      }, 200);
    },
    BackToCalendar() {
      if (this.eventDirty) {
        this.getStoreCalendar()
        this.Mode = 'calendar'
      }
      else {
        this.Mode = 'calendar'
      }
    },
    ticketCardClick(ticket) {
      this.CView = 'schedule'
      this.ticketChanged(ticket)
    },
    ticketChanged(ticket) {
      // alert(JSON.stringify(ticket))
      this.workingTicket = {
        ticket_info:ticket
      }
      this.workingTicket.ticket_info.do_item_ids = ticket.do_items[0].ticket_do_item_id
      // 抓api,填充storelist與servicelist
      this.ticketNo = ticket.ticket_no
      this.getTicketInfoById(ticket)
    },
    getTicketList() {
      // 用戶的票卷列表
      let Param = {
        'module':'user_reserve',
        'method':'get_ticket_list',
        'used_stat':'unfinished',
        'ticket_src':'iuse',
        'keyword':'',
        'secret_member_mobile':'0988888887'
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.ticketList = data.data.ticket_list
      },this)
    },
    getTicketInfoByTicketNo() {
      this.ticketNo = this.ticketNo.trim()
      if (this.ticketNo.length !== 10) {
        if (this.ticketNo.length > 0) {
          // return
        }
        else {
          this.TicketServiceList = []
          this.storeList = []
          this.selectedStore = null
          this.selectedServiceItem = null
          return
        }
      }
      // 客服直接輸入aa票號取得分店列表,取代用戶登入抓取用戶票卷列表
      let Param = {
        'module':'customer_service',
        'method':'getTicketInfoForReserve',
        'ticket_no':this.ticketNo
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.workingTicket = data.data
          vm.work_do_item_id = data.data.ticket_info.do_item_ids.split(',')[0]
          vm.work_ticket_project_id = data.data.ticket_info.ticket_project_id
          vm.work_ticket_item_id = data.data.ticket_info.ticket_item_id
          
          vm.storeList = data.data.merchant_stores
          // 自動選擇第一個service_available=1的分店
          for (let i=0;i<vm.storeList.length;i++) {
            if (vm.storeList[i].service_available) {
              vm.selectedStore = vm.storeList[i]
            }
          }
          vm.TicketServiceList = data.data.ticket_info.service_items
          if (vm.TicketServiceList.length === 1) {
            vm.selectedServiceItem = vm.TicketServiceList[0]
          }
          vm.getStoreCalendar(vm)
      },this)
    },
    getTicketInfoById(ticket) {
      // 選定票卷後 抓出分店列表 篩選掉不能預約的店
      let Param = {
        'module':'user_reserve',
        'method':'getTicketInfoById',
        'ticket_item_id':ticket.ticket_item_id
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.workingTicket = {
            ticket_info:data.data
          }
          //vm.workingTicket.ticket_info.do_item_ids = vm.workingTicket.ticket_info.do_items[0].ticket_do_item_id
          //alert(JSON.stringify(data.data.ticket_info))
          vm.work_do_item_id = data.data.ticket_info.do_items[0].ticket_do_item_id
          vm.work_item_id = data.data.ticket_info.ticket_item_id
          vm.work_ticket_project_id = data.data.ticket_info.ticket_project_id
          vm.work_ticket_item_id = data.data.ticket_info.ticket_item_id
          vm.storeList = data.data.ticket_info.stores
          // 自動選擇第一個service_available=1的分店
          for (let i=0;i<vm.storeList.length;i++) {
            if (vm.storeList[i].service_available) {
              vm.selectedStore = vm.storeList[i]
            }
          }
          vm.TicketServiceList = data.data.ticket_info.services
          if (vm.TicketServiceList.length === 1) {
            vm.selectedServiceItem = vm.TicketServiceList[0]
          }
          vm.getStoreCalendar(vm)
      },this)
    },
    getStoreCalendar(vm) {
      if (vm === undefined) {
        vm = this
      }
      // 選定分店後,抓api載入課程的事件
      if (!vm.selectedStore.merchant_store_id || !vm.selectedServiceItem.ticket_project_service_item_id) {
        return
      }
      // alert(JSON.stringify(this.workingTicket))
      /*let Param = {
        'module':'user_ticket',
        'method':'getDayPlotSummaryViewNew',
        'merchant_store_id':vm.selectedStore.merchant_store_id,
        'ticket_project_service_item_id': vm.selectedServiceItem.ticket_project_service_item_id,
        //'ticket_do_item_id': vm.workingTicket.ticket_info.do_item_ids.split(',')[0],
        'ticket_do_item_id':vm.work_do_item_id,
        'view_start_date':vm.CalendarState.periodStart,
        'view_end_date':vm.CalendarState.periodEnd
      }
      vm.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          // 拆解eventsRaw成為這個行事曆的event
          // 逐日期判斷 有plot_items數量的,再判斷已預約數量,形成可預約與可候補事件
          // 若本人當日預約候補,則另外style 
          vm.eventList = vm.parseEvents(data.data.day_views)
          vm.eventDirty = false
      },vm)*/
      let Param = {
        'module':'user_reserve',
        'method':'getStoreReserveSummary',
        'store_id':vm.selectedStore.merchant_store_id,
        'merchant_service_id': vm.selectedServiceItem.merchant_service_id,
        'ticket_item_id':vm.work_item_id,
        'allow_connect':1,
        'view_start_date':vm.CalendarState.periodStart,
        'view_end_date':vm.CalendarState.periodEnd
      }
      vm.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          // 拆解eventsRaw成為這個行事曆的event
          // 逐日期判斷 有plot_items數量的,再判斷已預約數量,形成可預約與可候補事件
          // 若本人當日預約候補,則另外style 
          vm.eventList = vm.parseEvents2(data.data.calendar_data)
          vm.eventDirty = false
      },vm)
    },
    parseEvents2(events) {
      let eventList = []
      // key as day object foreach
      const today_str = this.getDateByStr()
      for (let i=0;i<events.length;i++) {
        if (events[i].plot_date >= today_str) {
          eventList.push({
            // id is required for event-click(or that event will not trigger)
            id:'e_'+events[i].plot_date,
            startDate:events[i].plot_date,
            title:events[i].rest_remark?events[i].rest_remark:(events[i].on_service?'可劃位':'公休'),
            classes:'',
          })
        }
      }
      return eventList
    },
    parseEvents(events) {
      let eventList = []
      // key as day object foreach
      const today_str = this.getDateByStr()
      for (let [key_date, date_state] of Object.entries(events)) {
        if (key_date >= today_str && date_state.status_text !== '') {
          let this_class = ''
          if (date_state.reserved_this_day) {
            this_class = "self-reserved"
            date_state.status_text = '已預約'
          }
          else if (date_state.waited_this_day) {
            this_class = "self-waited"
            date_state.status_text = '已候補'
          }
          else if (date_state.total_plot_items === date_state.total_reserved) {
            this_class = "can-only-wait"
          }
          // 手機日期狀態只顯示一個字不然都看不到
          let event_text = date_state.status_text
          if (this.checkMobile()) {
            event_text = event_text.substr(1,1)
          }
          eventList.push({
            // id is required for event-click(or that event will not trigger)
            id:'e_'+key_date+'_'+date_state.reserved_this_day,
            startDate:key_date,
            title:event_text,
            classes:this_class,
          })
        }
      }
      return eventList
    },
    parseCardContent2(plot) {
      // 依狀態應依序顯示已預約/已候補/可預約/可候補
      let subtitle = '申請劃位'
      if (plot.can_direct_reserve) {
        subtitle = "可預約"
      }
      return subtitle
    },
    parseCardContent(plot) {
      // 依狀態應依序顯示已預約/已候補/可預約/可候補
      let subtitle = '時段異常'
      if (plot.reserved_reservation_id > 0) {
        subtitle = "<span style='background-color:gray;'>已預約</span>"
      }
      else if (plot.waited_reservation_schedule_plot_waitlist_id > 0) {
        subtitle = "<span style='background-color:gray;'>已候補</span>"
      }
      else if (plot.my_waitlist_reservation) {
        subtitle = "<span style='background-color:gold;'>保留預約</span>"
      }
      else if (plot.can_schedule) {
        subtitle = "可預約"
      }
      else {
        subtitle = "可候補"
      }
      return subtitle
    },
    getTimeStr(datetime_str) {
      const arr = datetime_str.split(' ')
      const arr2 = arr[1].split(':')
      arr2.splice(2,1)
      return arr2.join(':')
    },
    getDayPlots2() {
      if (!this.selectedStore.merchant_store_id || !this.selectedServiceItem.merchant_service_id) {
        return
      }
      let Param = {
        'module':'user_reserve',
        'method':'getTicketPlotByStoreDate',
        'store_id':this.selectedStore.merchant_store_id,
        'merchant_service_id':this.selectedServiceItem.merchant_service_id,
        'ticket_item_id':this.work_item_id,
        'view_date':this.toISODateString(this.showDate),
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.dayPlots = data.data
      },this)
    },
    getDayPlots() {
      if (!this.selectedStore.merchant_store_id || !this.selectedServiceItem.ticket_project_service_item_id) {
        return
      }
      let Param = {
        'module':'user_ticket',
        'method':'getDayPlotDetailView',
        'merchant_store_id':this.selectedStore.merchant_store_id,
        //'ticket_project_id':this.workingTicket.ticket_info.ticket_project_id,
        'ticket_project_id':this.work_ticket_project_id,
        'ticket_project_service_item_id':this.selectedServiceItem.ticket_project_service_item_id,
        //'ticket_do_item_id':this.workingTicket.ticket_info.do_item_ids.split(',')[0],
        'ticket_do_item_id':this.work_do_item_id,
        'view_date':this.toISODateString(this.showDate),

      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.dayPlots = data.data.day_plots
      },this)
    },
    directReserve (plot) {
      // 直接call api完成劃位
      let Param = {
        module:'user_reserve',
        method:'makeReservationDirect',
        class_plot_start_item_id:plot.class_start_plot_item_id,
        ticket_item_id:this.work_item_id,
        merchant_service_id:this.selectedServiceItem.merchant_service_id
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.$bus.fnShowInfo("劃位成功")
          vm.eventDirty = true
          vm.BackToCalendar()
      },this)
    },
    negotiateApplyShow (plot) {
      this.applyTime = plot.time_str
      this.modalNegotiateAplly = true
    },
    plotClick2 (plot) {
      if (plot.can_direct_reserve) {
        this.directReserve(plot)
      }
      else {
        this.negotiateApplyShow(plot)
      }
    },
    plotClick (plot) {
      if (plot.reserved_reservation_id > 0) {
        this.cancelReservation(plot)
      }
      else if (plot.waited_reservation_schedule_plot_waitlist_id > 0) {
        if (plot.can_schedule) {
          this.makeReservationForWaitlist(plot)
        }
        else {
          this.cancelWaitlist(plot)
        }
      }
      else if (plot.can_schedule) {
        this.makeReservation(plot)
      }
      else if (plot.can_wait) {
        this.makeWaitList(plot)
      }
      else {
        this.$bus.fnShowInfo('此時段候補已滿不能操作')
      }
    },
    makeReservation(plot) {
      if (this.$bus.getRole() === 'admin') {
        // alert(JSON.stringify(plot))
        let Param = {
          'module':'customer_service',
          'method':'makeReservation',
          'ticket_item_id':this.work_ticket_item_id,
          'ticket_do_item_id':this.work_do_item_id,
          'plot_item_id':plot.plot_items[0].plot_item_id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              // 不能讓客服幫用戶取消預約,所以這裡不再confirm確認
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            // eslint-disable-next-line
            vm.getDayPlots()
            vm.$bus.fnShowInfo('預約成功')
            vm.eventDirty = true
        },this)
      }
      else {
        let Param = {
          'module':'user_ticket',
          'method':'make_reservation',
          //'ticket_do_item_id':this.workingTicket.ticket_info.do_item_ids.split(',')[0],
          'ticket_do_item_id':this.work_do_item_id,
          'plot_id':plot.plot_id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              if (data.data && data.data.confirm_re_reserve) {
                vm.$bus.fnShowConfirm(data.msg,function () {
                  // 若confirm後還會call api還有可能要再confirm要先手動呼叫關閉
                  vm.$bus.fnClosePopup()
                  // confirmed to change re-reserve
                  let Param = {
                    'module':'user_ticket',
                    'method':'make_reservation',
                    'ticket_do_item_id':vm.work_do_item_id,
                    'plot_id':plot.plot_id,
                    confirm_re_reserve: 1
                  }
                  vm.$bus.apiCall(Param, function (data, vm) {
                  if (data.ok === 0) {
                      setTimeout(() => {
                        vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                      }, 200);
                      return
                    }
                    // eslint-disable-next-line
                    vm.getDayPlots()
                    vm.$bus.fnShowInfo('預約成功')
                    vm.eventDirty = true
                  },vm)

                },null,vm)
              }
              else {
                vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                return
              }
            }
            vm.getDayPlots()
            vm.$bus.fnShowInfo('預約成功')
            vm.eventDirty = true
        },this)
      }
    },
    makeReservationForWaitlist(plot) {
      // 客服只能一般代預約,不能幫用戶候補轉預約
      if (this.$bus.getRole() === 'admin') {
        this.makeReservation(plot)
      }
      let Param = {
        'module':'user_ticket',
        'method':'make_reservation_for_waitlist',
        'waitlist_id':plot.waited_reservation_schedule_plot_waitlist_id,
        'confirm_re_reserve':0,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            // 還需要判斷是否為再確認一次,如果是,則要showConfirm,確認再呼叫一次
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.getDayPlots()
          vm.$bus.fnShowInfo('預約成功')
          vm.eventDirty = true
      },this)
    },
    makeWaitList(plot) {
      if (this.$bus.getRole() === 'admin') {
        this.$bus.fnShowInfo('客服不能代用戶候補')
        return
      }
      else {
        let Param = {
          'module':'user_ticket',
          'method':'make_wait_list',
          //'ticket_item_id':this.workingTicket.ticket_info.ticket_item_id,
          'ticket_do_item_id':this.work_do_item_id,
          'plot_id':plot.plot_id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.$bus.fnShowInfo('候補成功')
            vm.getDayPlots()
            vm.eventDirty = true
        },this)
      }
    },
    cancelReservation(plot) {
      if (this.$bus.getRole() === 'admin') {
        this.$bus.fnShowInfo('客服不能代用戶取消預約')
        return
      }
      else {
        let Param = {
          'module':'user_ticket',
          'method':'cancel_reservation',
          'reservation_id':plot.reserved_reservation_id,
          'confirm_abnormal_cancel':0,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.$bus.fnShowInfo('取消預約成功')
            // eslint-disable-next-line
            // 預約成功的話...要更新dayPlots下對應plot的數據,很麻煩啊,所以...reload吧
            // 如果效能不好,可以在預約成功時回傳那一天的plots回來
            // 否則就要迴圈檢查dayPlots,找到對應plot的值做修改(但仍不即時)
            vm.getDayPlots()
            vm.eventDirty = true
        },this)
      }
    },
    cancelWaitlist(plot) {
      if (this.$bus.getRole() === 'admin') {
        this.$bus.fnShowInfo('客服不需要代用戶取消候補')
        return
      }
      else {
        let Param = {
          'module':'user_ticket',
          'method':'cancel_wait_list',
          'reservation_schedule_plot_waitlist_id':plot.waited_reservation_schedule_plot_waitlist_id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.$bus.fnShowInfo('取消候補成功')
            // eslint-disable-next-line
            vm.getDayPlots()
            vm.eventDirty = true
        },this)
      }
    },
    getPlotCardClass2(plot) {
      let plot_class = 'can-negotiate'
      if (plot.can_direct_reserve) {
        plot_class = 'can-schedule'
      }
      return plot_class
    },
    getPlotCardClass(plot) {
      let plot_class = 'only-wait'
      if (plot.reserved_reservation_id > 0) {
        plot_class = 'reserved'
      }
      else if (plot.my_waitlist_reservation && plot.can_schedule) {
        plot_class = 'my-reservation'
      }
      else if (plot.waited_reservation_schedule_plot_waitlist_id > 0) {
        plot_class = 'waited'
      }
      else if (plot.can_schedule) {
        plot_class = 'can-schedule'
      }
      return plot_class
    },
    getTicketImg(ticket) {
      const ImgBaseUrl = "https://tw.i99.to/product/"
      const ImgSizeKey = this.checkMobile()?"/ad270x145":"/ad420x225"
      return ImgBaseUrl+ticket.product_id+ImgSizeKey+ticket.pic_url
    },
  },
  computed: {
    /*readySend: {
      cache: false,
      get () {
        if (  this.formData.schedule_start_date &&
              this.formData.schedule_end_date &&
              this.formData.default_quota_per_plot &&
              this.formData.initial_reserve_remark &&
              this.tmpDayPlots.length > 0
        ) {
          return false
        }
        else {
          return true
        }
      }
    }*/
  },
  created: function () {
    const date = new Date()
    const period_start_date = new Date(date.getFullYear,date.getMonth,1)
    const period_end_date = new Date(date.getFullYear,date.getMonth+1,0)
    
    // 預設本月第一天到最後一天,切換會刷新,初始值要自己先設定
    this.CalendarState = {
      'periodStart': this.toISODateString(period_start_date),
      'periodEnd': this.toISODateString(period_end_date),
    }

    // 用戶使用時,預讀取票卷列表
    if (!this.$bus.session) {
      // 要重登入
      this.$bus.session = undefined
    }
    if (this.$bus.getRole()==='user') {
      this.getTicketList();
    }
  },
  mounted () {
    this.updateCount()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.calendar-wrapper {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  height: 67vh;
  width: 75vw;
  margin-left: auto;
  margin-right: auto;
}
/*要為日期選擇cell狀態加class要這樣加,如以下才增加orange class的效果*/
.theme-default >>> .cv-day.orange {
	background-color: orange;
}
.theme-default >>> .cv-event {
  bottom:0px;
  opacity: 0.7;
  cursor:pointer;
}
.theme-default >>> .cv-event.self-reserved {
  color:pink;
  font-weight: bolder;
  background-color:darkred; 
}
.theme-default >>> .cv-event.self-waited {
  color:darkolivegreen;
  font-weight: bolder;
  background-color:darkred; 
}
.theme-default >>> .cv-event.can-only-wait {
  color:lightyellow;
  background-color:cadetblue; 
}
.reserved {
  color:pink;
  font-weight: bolder;
  background-color: darkred;
}
.waited {
  color:darkolivegreen;
  font-weight: bolder;
  background-color:darkred; 
}
.my-reservation {
  color:mediumblue;
  font-weight: bolder;
  background-color: gold;
}
.can-schedule {
  background-color: antiquewhite;
}
.can-negotiate {
  background-color:cadetblue;
}
.only-wait {
  background-color:cadetblue;
}
.event-card {
  cursor:pointer;
  width:40%;
  margin-bottom:20px;
}
.ticket-card {
  cursor:pointer;
  font-size:10px;
  margin-bottom:20px;
  min-width:35%;
}
.ticket-card >>> div {
  display:inline;
  margin:0px;
}
.ticket-card >>> canvas {
  width:20%;
  height:80%;
}
</style>
